import { render, staticRenderFns } from "./ResourceLeader.vue?vue&type=template&id=51796fa2&scoped=true"
import script from "./ResourceLeader.vue?vue&type=script&lang=js"
export * from "./ResourceLeader.vue?vue&type=script&lang=js"
import style0 from "./ResourceLeader.vue?vue&type=style&index=0&id=51796fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51796fa2",
  null
  
)

export default component.exports